// src/components/Auth/AdminRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../../hooks';
import { DSSpinner } from '../Forms';

function AdminRoute() {
  const { user, isAdmin, isLoading } = useUser();

  if (isLoading) {
    return (
      <div style={{ height: '100vh' }}>
        <DSSpinner variant="page" size="md" label="Checking permissions..." />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (!isAdmin) {
    return (
      <div style={{ textAlign: 'center', padding: 'var(--space-16)' }}>
        <div className="alert error" style={{ maxWidth: 400, margin: '0 auto' }}>
          <div className="alert-title">Access Denied</div>
          You do not have permission to view this page. Admin role required.
        </div>
      </div>
    );
  }

  return <Outlet />;
}

export default AdminRoute;
